import { FaCreditCard } from 'react-icons/fa';

const CreditCard = ({ size = 48, color = "#CCC" }) => {
    return <FaCreditCard size={size} color={color} />
}

export default CreditCard